const tshirts = [
  {
    id: 7,
    name: "Successful",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/pTw1rbZR/45.png",
        backImage: "https://i.postimg.cc/HxqPnD2T/47.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/DZ9Y0kgv/41.png",
        backImage: "https://i.postimg.cc/xCwF8DRd/43.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/kXzjbv15/38.png",
        backImage: "https://i.postimg.cc/kXzjbv14/39.png"
      },
      {
        name: "Chocolate",
        frontImage: "https://i.postimg.cc/Pr96wQ3f/36.png",
        backImage: "https://i.postimg.cc/BQkhKBYQ/37.png"
      }
    ]
  },
  {
    id: 1,
    name: "Sandy",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/5y9p64z2/133.png",
        backImage: "https://i.postimg.cc/6q6zyWZ6/131.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/RhCGNStF/137.png",
        backImage: "https://i.postimg.cc/7hPXfHzL/135.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/9FKx7Y8B/89.png",
        backImage: "https://i.postimg.cc/9FKx7Y8b/90.png"
      }
    ]
  },
  {
    id: 8,
    name: "Hustle",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/wBTKYpWf/57.png",
        backImage: "https://i.postimg.cc/DzyV3TCp/59.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/5tNcWVPk/53.png",
        backImage: "https://i.postimg.cc/ZqKkzSfM/55.png"
      }
    ]
  },
  {
    id: 2,
    name: "Lobster",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/5y9p64z1/122.png",
        backImage: "https://i.postimg.cc/brYLsynh/120.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/fyW5JzdD/126.png",
        backImage: "https://i.postimg.cc/ZnYjCbNJ/124.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/7YdB2nsn/80.png",
        backImage: "https://i.postimg.cc/CLXvqsPG/79.png"
      }
    ]
  },
  {
    id: 9,
    name: "Overthinking",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/ZKrX9R2s/64.png",
        backImage: "https://i.postimg.cc/DyqRWZHD/66.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/02ph6QFB/61.png",
        backImage: "https://i.postimg.cc/Ghk6B2Vf/63.png"
      }
    ]
  },
  {
    id: 3,
    name: "Portofino",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/pr0CjwQV/148.png",
        backImage: "https://i.postimg.cc/1XWBFk0m/146.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/GtMKDWPT/151.png",
        backImage: "https://i.postimg.cc/7hB9zF1L/149.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/JzXpcHvB/93.png",
        backImage: "https://i.postimg.cc/g2hgqLQZ/94.png"
      }
    ]
  },
  {
    id: 10,
    name: "VELNO Club #1",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/xTS4SQ8s/71.png",
        backImage: "https://i.postimg.cc/SNpvp4Rw/73.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/SNpvp4RP/67.png",
        backImage: "https://i.postimg.cc/yYzbzKx5/69.png"
      }
    ]
  },
  {
    id: 4,
    name: "Cocktail",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/5y9p64C7/108.png",
        backImage: "https://i.postimg.cc/Gt3zHLyz/106.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/nrVTCFDd/112.png",
        backImage: "https://i.postimg.cc/mkZVtLHm/110.png"
      }
    ]
  },
  {
    id: 11,
    name: "Evolution",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/G25qN0NX/78.png",
        backImage: "https://i.postimg.cc/Qty0PLPJ/77.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/1tjJTxTK/76.png",
        backImage: "https://i.postimg.cc/1tjJTxTJ/75.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/fTpH9f2J/57.png",
        backImage: "https://i.postimg.cc/c42DnB96/56.png"
      }
    ]
  },
  {
    id: 5,
    name: "Santorini",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Blanco con Azul",
        frontImage: "https://i.postimg.cc/G2xqL8Hv/92.png",
        backImage: "https://i.postimg.cc/G2xqL8Hk/90.png"
      },
      {
        name: "Blanco con Negro",
        frontImage: "https://i.postimg.cc/Hx9BYcVM/96.png",
        backImage: "https://i.postimg.cc/pTJqWhpz/94.png"
      },
      {
        name: "Negro con Azul",
        frontImage: "https://i.postimg.cc/PxQ2XpPV/104.png",
        backImage: "https://i.postimg.cc/QtJ089Hy/102.png"
      },
      {
        name: "Negro con Blanco",
        frontImage: "https://i.postimg.cc/9MYJmRrk/100.png",
        backImage: "https://i.postimg.cc/ydyv1gkf/98.png"
      }
    ]
  },
  {
    id: 12,
    name: "911",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/TPjzZPqk/82.png",
        backImage: "https://i.postimg.cc/C1F3YVmc/84.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/25dsP5FX/80.png",
        backImage: "https://i.postimg.cc/d1qbvK4B/81.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/TYFkDJ75/61.png",
        backImage: "https://i.postimg.cc/8P9y6mKF/60.png"
      },
      {
        name: "Chocolate",
        frontImage: "https://i.postimg.cc/Pr96wQ3Y/62.png",
        backImage: "https://i.postimg.cc/xThsz3xL/63.png"
      }
    ]
  },
  {
    id: 6,
    name: "Plain t-shirt",
    price: 20.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/TwQgNB7W/43.png",
        backImage: "https://i.postimg.cc/hvjxkM64/44.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/qRQyDWbz/42.png",
        backImage: "https://i.postimg.cc/k4wKYL1D/41.png"
      }
    ]
  },
  {
    id: 13,
    name: "Process",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Yq4CC6FH/43.png",
        backImage: "https://i.postimg.cc/657pprZt/44.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/52L9wfpB/42.png",
        backImage: "https://i.postimg.cc/CK0h79QT/41.png"
      }
    ]
  },
  {
    id: 14,
    name: "World",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/D0Snmh89/47.png",
        backImage: "https://i.postimg.cc/NGnQSKz1/48.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/T1BGDsbP/46.png",
        backImage: "https://i.postimg.cc/cCPZnz3C/45.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/CLzP5QNF/18.png",
        backImage: "https://i.postimg.cc/7YfshWVq/19.png"
      },
      {
        name: "Chocolate",
        frontImage: "https://i.postimg.cc/J4G602q8/14.png",
        backImage: "https://i.postimg.cc/GhH7t5Qd/15.png"
      }
    ]
  },
  {
    id: 15,
    name: "Rio",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Y0LBMxsg/52.png",
        backImage: "https://i.postimg.cc/pLHrc99L/51.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/3RRHbhCR/49.png",
        backImage: "https://i.postimg.cc/3RVJXWMC/50.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/4Nq89QLg/23.png",
        backImage: "https://i.postimg.cc/tCYSJM57/22.png"
      }
    ]
  },
  {
    id: 16,
    name: "Kindness",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/qRhpv0tt/56.png",
        backImage: "https://i.postimg.cc/mr6b4hrR/55.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/htsDC2WV/54.png",
        backImage: "https://i.postimg.cc/bwgy6mc0/53.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/L6wy13CR/31.png",
        backImage: "https://i.postimg.cc/ncgdDGRx/30.png"
      }
    ]
  },
  {
    id: 17,
    name: "Disappointed",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Chocolate",
        frontImage: "https://i.postimg.cc/ncCRrP1N/2.png",
        backImage: "https://i.postimg.cc/WbhWzH7C/3.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/J4G602Qg/4.png",
        backImage: "https://i.postimg.cc/5N67yRmr/5.png"
      }
    ]
  },
  {
    id: 18,
    name: "Padel?",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/zfhn0z0W/16.png",
        backImage: "https://i.postimg.cc/yNRFv1vZ/15.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/1zFpJmJf/11.png",
        backImage: "https://i.postimg.cc/zfhn0z0L/12.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/bvnQ3y3r/14.png",
        backImage: "https://i.postimg.cc/1zFpJmJ4/13.png"
      }
    ]
  },
  {
    id: 19,
    name: "Out Of",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/KzytW6Hg/22.png",
        backImage: "https://i.postimg.cc/sXR5LkNG/21.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/HxCbNqhJ/20.png",
        backImage: "https://i.postimg.cc/76ySRFW5/19.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/vmnW3Y3f/17.png",
        backImage: "https://i.postimg.cc/nLmv0F0q/18.png"
      }
    ]
  },
  {
    id: 20,
    name: "Tennis",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/3RH2qsc2/26.png",
        backImage: "https://i.postimg.cc/tTHFcKMW/25.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/B6G2zrVF/23.png",
        backImage: "https://i.postimg.cc/k4dWH0p8/24.png"
      }
    ]
  },
  {
    id: 21,
    name: "Snow",
    price: 25.00,
    description: "Corte oversize premium con caída perfecta y tejido ultra suave de alta calidad de gramaje de algodón de 270 gramos.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/hjqVYk5r/30.png",
        backImage: "https://i.postimg.cc/ZRh6QGMx/29.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/SspcPBvV/32.png",
        backImage: "https://i.postimg.cc/C1Vb23Q7/31.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/DZK1N9Mr/27.png",
        backImage: "https://i.postimg.cc/SspcPBvL/28.png"
      }
    ]
  }
];

const hoodies = [
  {
    id: 1,
    name: "Sandy",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Pxd14d4G/20.png",
        backImage: "https://i.postimg.cc/FRh0ZhZ5/19.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/rmq5Jq9B/18.png",
        backImage: "https://i.postimg.cc/mDT7wTSn/17.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/rszgbx4N/82.png",
        backImage: "https://i.postimg.cc/9MLJJJDg/81.png"
      }
    ]
  },
  {
    id: 2,
    name: "Lobster",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/V6zXRzR8/22.png",
        backImage: "https://i.postimg.cc/Pxd14d4k/21.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Hx3XvFSN/24.png",
        backImage: "https://i.postimg.cc/G2zGg6Mg/23.png"
      }
    ]
  },
  {
    id: 3,
    name: "Portofino",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/63BC0Bhb/16.png",
        backImage: "https://i.postimg.cc/DZ71g7cj/15.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/xC9LR9P6/14.png",
        backImage: "https://i.postimg.cc/Y9tQ3txb/13.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/Qtf000Fb/73.png",
        backImage: "https://i.postimg.cc/rmfQQQD5/72.png"
      }
    ]
  },
  {
    id: 4,
    name: "Cocktail",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/4dwV2j8r/26.png",
        backImage: "https://i.postimg.cc/3R9mfzLV/25.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/9M1Zgs85/28.png",
        backImage: "https://i.postimg.cc/rmgxZ7hB/27.png"
      }
    ]
  },
  {
    id: 5,
    name: "Santorini",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Blanco con Azul",
        frontImage: "https://i.postimg.cc/63znbFj9/33.png",
        backImage: "https://i.postimg.cc/PxKYV03T/31.png"
      },
      {
        name: "Blanco con Negro",
        frontImage: "https://i.postimg.cc/d1nrNgHF/30.png",
        backImage: "https://i.postimg.cc/cHTwkP9G/29.png"
      },
      {
        name: "Negro con Azul",
        frontImage: "https://i.postimg.cc/0QZDXhWQ/38.png",
        backImage: "https://i.postimg.cc/63znbFjp/37.png"
      },
      {
        name: "Negro con Blanco",
        frontImage: "https://i.postimg.cc/MTtV3gPK/36.png",
        backImage: "https://i.postimg.cc/MTtV3gP6/35.png"
      }
    ]
  },
  {
    id: 6,
    name: "Plain hoodie",
    price: 25.00,
    description: "Sudadera básica de algodón puro con capucha, ideal para el día a día. Comodidad y estilo en una sola prenda.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/HxTb2Tt4/7.png",
        backImage: "https://i.postimg.cc/FRh0ZhxV/9.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/2SfMGqVx/10.png",
        backImage: "https://i.postimg.cc/j5RyXRhX/12.png"
      }
    ]
  },
  {
    id: 7,
    name: "Process",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/0QFvWQhF/2.png",
        backImage: "https://i.postimg.cc/63gKj3FF/1.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/vBkyqBpR/3.png",
        backImage: "https://i.postimg.cc/W3CVW3xQ/4.png"
      }
    ]
  },
  {
    id: 8,
    name: "World",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/wvZzfvS6/6.png",
        backImage: "https://i.postimg.cc/RFymsFj9/5.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/KjT2dby6/7.png",
        backImage: "https://i.postimg.cc/gjhWfpWb/8.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/g2htmV7c/13.png",
        backImage: "https://i.postimg.cc/x1mpnvZX/14.png"
      }
    ]
  },
  {
    id: 9,
    name: "Rio",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/1XFQLSQS/10.png",
        backImage: "https://i.postimg.cc/D0GTthT7/9.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/J0XL98Lh/11.png",
        backImage: "https://i.postimg.cc/nrmJ6xJz/12.png"
      }
    ]
  },
  {
    id: 10,
    name: "Kindness",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Xq5bTWbZ/14.png",
        backImage: "https://i.postimg.cc/NFXcWtc5/13.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/gjhWfpWR/15.png",
        backImage: "https://i.postimg.cc/mk9s04s7/16.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/bvjCJGXk/25.png",
        backImage: "https://i.postimg.cc/SKpTsX07/26.png"
      }
    ]
  },
  {
    id: 11,
    name: "Hustle",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Y2LM46Wv/26.png",
        backImage: "https://i.postimg.cc/T25fyVDh/25.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/ryRMd1ry/23.png",
        backImage: "https://i.postimg.cc/vHRM54rM/24.png"
      }
    ]
  },
  {
    id: 12,
    name: "Overthinking",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/TY8GnKVh/30.png",
        backImage: "https://i.postimg.cc/YqthzdR9/29.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/PrGh1CWd/27.png",
        backImage: "https://i.postimg.cc/c4drBFhC/28.png"
      }
    ]
  },
  {
    id: 13,
    name: "Successful",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/y63sJmZK/22.png",
        backImage: "https://i.postimg.cc/SQYkX6Mp/21.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/QNKhBQW2/19.png",
        backImage: "https://i.postimg.cc/RCJ437HB/20.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/0NdtJ8xV/37.png",
        backImage: "https://i.postimg.cc/5tqPFx1K/38.png"
      }
    ]
  },
  {
    id: 14,
    name: "VELNO Club #1",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/7YvDS53X/34.png",
        backImage: "https://i.postimg.cc/m2xR7PY8/33.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/jdVKyDHJ/31.png",
        backImage: "https://i.postimg.cc/KvXFt1P5/32.png"
      }
    ]
  },
  {
    id: 15,
    name: "Evolution",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/ZKrmHJHV/38.png",
        backImage: "https://i.postimg.cc/fTxsCMC5/37.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/284YGCGn/35.png",
        backImage: "https://i.postimg.cc/TYrx0T00/36.png"
      },
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/j5MZZZD2/62.png",
        backImage: "https://i.postimg.cc/yd1Lmw83/61.png"
      }
    ]
  },
  {
    id: 16,
    name: "911",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/Nf1tDQbq/42.png",
        backImage: "https://i.postimg.cc/yYFKj7jG/41.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/xTKQ595s/39.png",
        backImage: "https://i.postimg.cc/X7wWLnxM/40.png"
      }
    ]
  },
  {
    id: 17,
    name: "Padel?",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/zv2spFGp/1.png",
        backImage: "https://i.postimg.cc/zv2spFGp/1.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/L4yFH2Bc/5.png",
        backImage: "https://i.postimg.cc/XN26V4k6/6.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/QCY2SJdq/3.png",
        backImage: "https://i.postimg.cc/nrSyTGh2/4.png"
      }
    ]
  },
  {
    id: 18,
    name: "Out Of",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/wxWY6gQd/8.png",
        backImage: "https://i.postimg.cc/kMjPnqvr/7.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/CMvpFSsw/11.png",
        backImage: "https://i.postimg.cc/9XxHWCYW/12.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/v8PwQbtM/9.png",
        backImage: "https://i.postimg.cc/Wp9c2TwT/10.png"
      }
    ]
  },
  {
    id: 19,
    name: "Tennis",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/ryh28MNd/17.png",
        backImage: "https://i.postimg.cc/sfnCVs4G/18.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/pV0M2RJT/15.png",
        backImage: "https://i.postimg.cc/8kyg1Nms/16.png"
      }
    ]
  },
  {
    id: 20,
    name: "Snow",
    price: 30.00,
    description: "Sudadera premium con capucha, caída perfecta y tejido ultra suave de alto gramaje de algodón.",
    colors: [
      {
        name: "Navy",
        frontImage: "https://i.postimg.cc/1RW19srF/20.png",
        backImage: "https://i.postimg.cc/nVdfHpGQ/19.png"
      },
      {
        name: "Blanco",
        frontImage: "https://i.postimg.cc/CLzT5Xcz/23.png",
        backImage: "https://i.postimg.cc/7Yf8hdK5/24.png"
      },
      {
        name: "Negro",
        frontImage: "https://i.postimg.cc/HWS1pd9Q/21.png",
        backImage: "https://i.postimg.cc/v8PwQbtr/22.png"
      }
    ]
  }
];

export { tshirts, hoodies };